import type { ModalFuncProps } from "antd";

/** The "Are you sure?" prompt for deleting a run, or cancelling one that's still processing. */
export const getAnalysisCollectionDeleteConfirm = (
  name: string,
  action: "delete" | "cancel" = "delete"
): ModalFuncProps =>
  action === "delete"
    ? {
        title: "Are you sure?",
        content:
          "Deleting this item is permanent and will affect all members of your organisation. Would you like to proceed?",
        okText: "Delete",
        cancelText: "Cancel",
      }
    : {
        title: "Are you sure?",
        content: `Are you sure you wish to cancel processing of ${name}? All previously uploaded data on these assets will be lost. You will not be charged.`,
        okText: "Cancel Processing",
        cancelText: "Go back",
      };
